import {Component, Inject, OnInit} from '@angular/core';
import {GlobalConstants} from "../../../../common/global-constants";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {ConfigurationService} from "../../../../services/configuration.service";
import {AuthenticationService} from "../../../../services/authentication.service";
import {CommonUtils} from "../../../../utils/common.utils";
import {DataService} from "../../../../services/data.service";


@Component({
  selector: 'app-update-transit-time-s3',
  templateUrl: './update-transit-time-s3.component.html',
  styleUrls: ['./update-transit-time-s3.component.scss']
})

export class UpdateTransitTimeS3Component implements OnInit {

  updateTransitTimeS3URL = GlobalConstants.PROCESS_TRANSIT_TIME_FILE_UPLOAD_TO_BUSINESS_S3;
  processTransitTimeRequestURL = GlobalConstants.PROCESS_TRANSIT_TIME_REQUEST_ENDPOINT;
  updateTransitTimeS3Form: FormGroup;

  fromCountryCodeOptions: any[];
  transitTimeOptions: any[];
  transitTimeConfigurations: any[];

  s3FilePathOptions: any[];
  loading = false;

  records: any[];

  uploadBuckets: any;
  countryCodes: any;

  currentComponentKeyPlaceholder = [];
  currentWorkingRecord: any;

  items: any;
  dropDownOptions: any;

  user = {};

  help_messages : any = this.dataService.help_messages;

  get passportEnabledShipmethods(){
    return this.dataService.passportEnabledShipmethods;
  }

  constructor(@Inject('RequestsService') private requestsService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              @Inject('S3Utils') private s3Utils,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              private dataService: DataService) {

  }


  async ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.updateTransitTimeS3Form = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyValue: ['', Validators.required],
      componentKeyPlaceholder: [''],
      transitTimeType: ['', Validators.required],
      s3FilePath: ['', Validators.required]
    });

    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptions;
    this.s3FilePathOptions = await this.s3Utils.getAllS3FilePath(this.commonUtils.getBusinessBucket());
    this.items = this.commonUtils.getItemsBasedOnArc();
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};

    this.updateTransitTimeS3Form.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.updateTransitTimeS3Form.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue('')
    this.currentComponentKeyPlaceholder = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.records = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }


  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(this.currentWorkingRecord, this.records);

    this.updateTransitTimeS3Form.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.updateTransitTimeS3Form.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());

    this.updateTransitTimeS3Form.get(GlobalConstants.TRANSIT_TIME_TYPE).setValue('');
  }

  public onTransitTimeTypeChange(transitTimeType) {
    if (transitTimeType == GlobalConstants.CARRIER_PROVIDED_KEYWORD) {
      alert(GlobalConstants.TRANSIT_TIME_TYPE_ALERT_MESSAGE);
    }
  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  public async submit() {

    let businessBucket = this.commonUtils.getBusinessBucket();
    let businessFileKey = this.updateTransitTimeS3Form.get(GlobalConstants.S3_FILE_PATH).value;
    let metadata = this.buildMetadata()
    let uploadBucket = metadata[GlobalConstants.BUCKET];
    let uploadKey = metadata[GlobalConstants.KEY]

    let requestBody = {}
    requestBody[GlobalConstants.TRANSIT_TIME_BUSINESS_BUCKET] = businessBucket;
    requestBody[GlobalConstants.TRANSIT_TIME_BUSINESS_FILE_KEY] = businessFileKey;
    requestBody[GlobalConstants.TRANSIT_TIME_UPLOAD_BUCKET] = uploadBucket;
    requestBody[GlobalConstants.TRANSIT_TIME_UPLOAD_FILE_KEY] = uploadKey;
    requestBody[GlobalConstants.METADATA] = JSON.stringify(metadata);
    console.log(requestBody)

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(metadata);
      this.loading = false;
      if (hasPermission === false){
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }

    // Call backend apis
    this.loading = true;
    this.requestsService.put(this.updateTransitTimeS3URL, requestBody).subscribe(data => {
      this.loading = false;
      this.toastrService.success(GlobalConstants.REQUEST_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }

  private buildMetadata(): String {
    // Creating metadata from input parameters
    let uploadBucket = this.commonUtils.getUploadBucket();
    let timestamp = Math.round(Date.now() / 1000);

    let metadata = JSON.parse(JSON.stringify(this.updateTransitTimeS3Form.value));
    metadata[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(metadata[GlobalConstants.COMPONENT_KEY_VALUE], metadata[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    metadata[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    let componentKeyValue = metadata[GlobalConstants.COMPONENT_KEY_VALUE].replace(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR, GlobalConstants.SLASH);
    let key = metadata[GlobalConstants.TRANSIT_TIME_TYPE] + GlobalConstants.SLASH + metadata[GlobalConstants.BUSINESS_UNIT] + GlobalConstants.SLASH + metadata[GlobalConstants.FROM_COUNTRY_CODE] + GlobalConstants.SLASH + componentKeyValue + GlobalConstants.SLASH + timestamp;
    metadata[GlobalConstants.BUCKET] = uploadBucket;
    metadata[GlobalConstants.KEY] = key;
    metadata[GlobalConstants.TIME_STAMP] = timestamp;
    metadata[GlobalConstants.ARC] = this.commonUtils.getArc();
    metadata[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    metadata[GlobalConstants.LOOK_UP_KEYS] = this.currentWorkingRecord[GlobalConstants.LOOK_UP_KEYS];
    delete metadata[GlobalConstants.CURRENT_TRANSIT_TIME];
    console.log(metadata);
    return metadata;
  }
}
